import {useEffect, useRef, useState} from "react";
import store from "../../../reducers/createReducers";
import associateServices from "../../../services";
import SESSION_HELPER from "../../../helpers/session-helper";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import FormButton from "../../../components/form-button";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import InputMask from "react-input-mask";
import InformationToast from "../../../components/toast/InformationToast";
import SvgIcon from "../../../components/svg-icon";
import {useSelector} from "react-redux";
import {GoogleOAuthProvider} from "@react-oauth/google";
import RegisterSocialAuth from "../register/social-auths";
import {LazyLoadImage} from "react-lazy-load-image-component";

const Login = props => {
    const {activeLanguage, theme} = useSelector(state => state.globalReducer)
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const maskRef = useRef(null)
    const {handleClose, handleModalAction} = props

    const [submitting, setSubmitting] = useState(false)
    const [errors, setErrors] = useState({})
    const [otp, setOtp] = useState('')
    const [instance, setInstance] = useState({
        username: '',
        password: '',
    })
    useEffect(() => {
        if (!authenticated) {
            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('signin-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

            mdl.classList?.add('modal-fade')

            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')

            }
        }

    }, [authenticated])

    const {t} = useTranslation();

    // const handleClose = () => store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))

    const handleChange = (type, value) => setInstance(prevState => ({
        ...prevState,
        [type]: value
    }))
    const handleLogin = () => {
        setErrors({})
        Object.keys(instance).forEach(function (key, index) {
            if (!instance[key] || instance[key] === '') {
                return setErrors(prevState => ({
                    ...prevState,
                    [key]: 'form-field-cant-be-null'
                }))
            }
        });


        if (Object.keys(errors)?.length >= 1) {
            console.log('NO = ', errors, Object.keys(errors))
            return false
        }

        setSubmitting(true)

        associateServices.login({
            ...instance,
            agent: SESSION_HELPER.getUserAgent()
        })
            .then(handleLoginResponse)
    }
    const handleOtpLogin = () => {
        setErrors({})
        if (!otp)
            return setErrors({
                otp: 'form-field-cant-be-null'
            })


        setSubmitting(true)

        associateServices.loginOtpVerify({
            type: 'login',
            secret,
            code: otp
        })
            .then(handleLoginResponse)
    }
    const [secret, setSecret] = useState('')
    const [step, setStep] = useState('login')

    useEffect(() => {
        if (step !== 'login' && maskRef?.current)
            maskRef?.current?.focus()
    }, [step, maskRef])
    const handleLoginResponse = (response) => {
        setSubmitting(false)

        if (response?.status !== 200)
            return toast(<InformationToast
                icon={'ti-error-404'}
                title={'...'}
                message={t(`api-notifications.${response?.errors}`)}
            />)

        if (response?.data?.otp) {

            setSecret(response?.data?.secret)
            return setStep(response?.data?.otp)
        }
        // store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))

        handleClose()
        store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(response?.data))
    }


    const handleAction = () => step === 'login' ? handleLogin() : handleOtpLogin()

    const [showPass, setShowPass] = useState(false)
    const [settings, setSettings] = useState(null)
    const [image, setImage] = useState(null)

    const handleHide = () => {
        setShowPass(prevState => !prevState)
    }

    useEffect(() => {
        associateServices.getAuthSettings({
            model: 'login',
            language: activeLanguage?.key,
            theme
        }).then(res => {
            if (res?.data?.image?.image) {
                setImage(res?.data?.image?.image)

                const mdl = document.getElementById('signin-modal')
                mdl.classList?.add('modal--sign')
            }


            setSettings(res?.data?.settings)
        })
    }, [activeLanguage?.key, theme])

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && instance?.password && instance?.username)
            handleAction()
    }
    return (

        <div
            className="modal fade"
            id="signin-modal"
            tabIndex={-1}
            aria-labelledby="signin-modal"
            // aria-hidden="true"
            // onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">

                        {
                            image &&
                            <div className="modal__sign-img">
                                {/*<img*/}
                                {/*    src={image}*/}
                                {/*    alt=""/>*/}

                                <LazyLoadImage
                                    height={'100%'}
                                    width={'100%'}
                                    effect="blur"
                                    src={image}
                                    placeholderSrc={image}
                                    alt=""/>
                            </div>
                        }

                        <div className="modal__head">
                            <h6 className="modal__title">
                                {t('modals.login.sign-in')}
                            </h6>
                            <button
                                className="modal__close"
                                type="button"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <div className="modal__form">
                            {
                                step === 'login' ?
                                    <>
                                        <div className="form__group">
                                            <label htmlFor="" className="form__label">
                                                {t('modals.login.email-or-username')} <b>*</b>
                                            </label>
                                            <input
                                                onKeyDown={handleKeyDown}

                                                value={instance.username}
                                                onChange={e => handleChange('username', e.target.value)}
                                                type="text" className="form__input"/>

                                            {
                                                errors?.username &&
                                                <p className="form__note error">
                                                    * {errors?.username}
                                                </p>
                                            }
                                        </div>

                                        <div className="form__group form__group--pass0">
                                            <label htmlFor="" className="form__label">
                                                {t('modals.login.password')} <b>*</b>
                                            </label>
                                            <input
                                                onKeyDown={handleKeyDown}
                                                value={instance.password}
                                                autoComplete={"current-password"}
                                                onChange={e => handleChange('password', e.target.value)}
                                                type={showPass ? 'text' : 'password'} className="form__input"
                                                id="pass0"/>

                                            <button className="form__pass" type="button" onClick={handleHide}>
                                                <SvgIcon id={showPass ? 'eye-hidden' : 'eye-show'}/>
                                            </button>
                                        </div>
                                        {
                                            errors?.username &&
                                            <p className="form__note error">
                                                * {errors?.pass}
                                            </p>
                                        }
                                    </>
                                    :
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            {step === '2fa' ? t('modals.login.enter-2fa-code') : t('modals.login.enter-otp-code')}
                                            <b>*</b>
                                        </label>
                                        <InputMask
                                            onKeyDown={handleKeyDown}
                                            mask={'999999'}
                                            maskPlaceholder={null}
                                            disabled={step === 'login'}
                                            className="form__input"
                                            value={otp || ''}
                                            onChange={e => setOtp(e.target.value)}
                                            type="text" // Set type to text
                                            inputMode="numeric" // Hint for numeric keyboard
                                            ref={maskRef}
                                        />
                                    </div>

                            }


                            <FormButton
                                loading={submitting}
                                disabled={step === 'login' ? submitting : submitting || step === 'login' || otp?.length !== 6}
                                onClick={handleAction}
                                label={t('modals.login.sign-in')}
                            />

                            <span className="form__delimiter">
                                <span>
                                    {t('modals.login.or')}
                                </span>
                              </span>

                            {
                                settings?.id &&

                                <RegisterSocialAuth loading={submitting} handleClose={handleClose}
                                                    settings={settings}
                                                    setLoading={setSubmitting}/>

                            }


                            <div className="form__text">
                                <p>
                                    <button
                                        type="button"
                                        // onClick={e => store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('forgot-password'))}
                                        onClick={e => handleModalAction('forgot-password')}
                                    >
                                        {t('modals.login.forgot-password')}
                                    </button>
                                </p>
                                <p>
                                    {t('modals.login.dont-have-account')}{" "}
                                    <button
                                        type="button"
                                        // onClick={e => store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('register'))}
                                        onClick={e => handleModalAction('register')}

                                    >
                                        {t('modals.login.register-an-account')}
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )

}

export default Login
